// app/annual_report_easy_file/components/CustomHeader.tsx
"use client";

import * as React from "react";
import Link from "next/link";
import Image from "next/image";
import { Menu, X } from "lucide-react";
import { cn } from "@/lib/utils";

export function CustomHeader() {
  const [open, setOpen] = React.useState(false);

  // route değişince menüyü kapat (basit UX)
  React.useEffect(() => {
    const close = () => setOpen(false);
    window.addEventListener("popstate", close);
    return () => window.removeEventListener("popstate", close);
  }, []);

  return (
    <header className="w-full border-b bg-white">
      <div className="mx-auto w-full max-w-5xl px-4 lg:px-0">
        <div className="h-16 sm:h-20 flex items-center justify-between">
          {/* Left: Logo */}
          <Link href="#" className="flex items-center gap-3" onClick={() => setOpen(false)}>
            {/* The new design's logo, same asset and same rendered size as
                NavbarPublic (128x49 from /assets/public/landing/). The old
                declaration was /file-business-logo.webp at 190x48 — a 3.96:1
                box for an image that is really 2.59:1, so next/image reserved
                the wrong space and `w-auto` had to correct it after load. */}
            <Image
              src="/assets/public/landing/file-business-logo.webp"
              alt="File Business"
              width={128}
              height={49}
              priority
              className="h-10 w-auto sm:h-[49px]"
            />
          </Link>

          {/* Desktop nav */}
          <nav className="hidden sm:flex items-center gap-8">
            <Link
              href="/help-center"
              className="text-[15px] font-semibold text-[#0D3C61] hover:text-slate-900 transition-colors"
            >
              Support Center
            </Link>

            <Link
              href="/tracking"
              className="text-[15px] font-semibold text-[#0D3C61] hover:text-slate-900 transition-colors"
            >
              Order Status
            </Link>

            <Link
              href="/login"
              className="inline-flex items-center justify-center h-11 px-6
                         bg-[#4569FD] text-white text-[15px] font-semibold
                         hover:opacity-90 transition rounded-xl"
            >
              Start a New Filing
            </Link>
          </nav>

          {/* Mobile menu button */}
          <button
            type="button"
            className="sm:hidden inline-flex items-center justify-center h-10 w-10 rounded-xl border bg-white"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>

        {/* Mobile dropdown */}
        <div
          className={cn(
            "sm:hidden overflow-hidden transition-[max-height,opacity] duration-200",
            open ? "max-h-80 opacity-100 pb-4" : "max-h-0 opacity-0"
          )}
        >
          <div className="pt-2 grid gap-2">
            <Link
              href="/help-center"
              onClick={() => setOpen(false)}
              className="rounded-xl px-3 py-3 text-[15px] font-semibold text-[#0D3C61] hover:bg-slate-50"
            >
              Support Center
            </Link>

            <Link
              href="/tracking"
              onClick={() => setOpen(false)}
              className="rounded-xl px-3 py-3 text-[15px] font-semibold text-[#0D3C61] hover:bg-slate-50"
            >
              Order Status
            </Link>

            <Link
              href="/login"
              onClick={() => setOpen(false)}
              className="inline-flex items-center justify-center h-11 rounded-xl
                         bg-[#4569FD] text-white text-[15px] font-semibold
                         hover:opacity-90 transition"
            >
              Start a New Filing
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
}
